import { Themes } from '../configs/Themes';

const THEME_FIELD = 'currenttheme=';

/**
 * @description InitTheme.
 */
export function initTheme() {
	themeHandler();
	window.addEventListener('storage', (event) => {
		if (event.key === THEME_FIELD) {
			themeHandler();
		}
	});
}

// To handle theme value in localStorage.
/**
 * @description ThemeHandler.
 */
export function themeHandler() {
	if (window.matchMedia?.('(prefers-color-scheme: dark)')) {
		const currentTheme = localStorage.getItem(THEME_FIELD) as Themes;
		const systemDarkTheme = window.matchMedia(
			'(prefers-color-scheme: dark)',
		);

		if (!currentTheme) {
			setTheme(systemDarkTheme.matches ? Themes.dark : Themes.light);
			if (systemDarkTheme && 'addEventListener' in systemDarkTheme) {
				systemDarkTheme.addEventListener('change', (event) => {
					const newColorScheme = event.matches
						? Themes.dark
						: Themes.light;
					setTheme(newColorScheme);
				});
			}
		} else {
			setTheme(currentTheme);
		}
	}
}
/**
 * @description SetTheme.
 */
export function setTheme(theme: Themes) {
	const themeColor = document.querySelector('meta[name="theme-color"]');
	const msNavBar = document.querySelector(
		'meta[name="msapplication-navbutton-color"]',
	);
	const appleNavBar = document.querySelector(
		'meta[name="apple-mobile-web-app-status-bar-style"]',
	);
	let color = '#ffffff';
	if (theme === Themes.light) {
		document.documentElement.setAttribute('theme', Themes.light);
	} else {
		document.documentElement.setAttribute('theme', Themes.dark);
		color = '#ffffff';
	}

	if (themeColor && msNavBar && appleNavBar) {
		themeColor.setAttribute('content', color);
		msNavBar.setAttribute('content', color);
		appleNavBar.setAttribute('content', color);
	} else {
		const themeColorMeta = document.createElement('meta');
		const msNavBarMeta = document.createElement('meta');
		const appleNavBarMeta = document.createElement('meta');
		themeColorMeta.name = 'theme-color';
		msNavBarMeta.name = 'msapplication-navbutton-color';
		appleNavBarMeta.name = 'apple-mobile-web-app-status-bar-style';
		themeColorMeta.content = color;
		msNavBarMeta.content = color;
		appleNavBarMeta.content = color;
		document
			.getElementsByTagName('head')[0]
			.append(themeColorMeta, msNavBarMeta, appleNavBarMeta);
	}
}
